






















































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { IUser } from "@/types/user";

@Component({
  components: {},
})
export default class extends Vue {
  @Getter("auth/me")
  public user!: IUser;

  @Getter("isLoading")
  public isLoading!: boolean;
}
